import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Accordion, Col, Container, Row} from 'react-bootstrap';
import {Link, useLocation} from 'react-router-dom';
import {connect} from 'react-redux'
import {gsap, TimelineLite} from "gsap/gsap-core";
import {CSSPlugin} from 'gsap/CSSPlugin'
import {hover, titletwo} from "../styles/globalStyleVars";

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';



const Menu = ({logo, color, img, setSectionId,getMenuClass}) => {
    const location = useLocation()
    let [menuItems, setMenuItems] = useState('false');
    gsap.registerPlugin(CSSPlugin);
    const [tl] = useState(new TimelineLite());

    let handleMenuToggle = (e) => {
        e.stopPropagation();
        setMenuItems('toggled');
    };

    let handleClose = () => {
        setMenuItems('');
    };

    let {pathname} = useLocation();

    const hamburgerRef = useRef(null)
    const menuRef = useRef(null)
    const mobileMenuRaf = useRef(null)

    useEffect(() => {
        window.addEventListener('scroll', function () {
            if (window.pageYOffset > 100) {
                // setNewClass('menu-fixed')
                document.querySelector(".menu-bar").classList.add('menu-fixed')
            } else {
                // setNewClass('menu')
                document.querySelector(".menu-bar")?.classList.remove('menu-fixed')
            }
        });
        const targetElement = document.querySelectorAll('body');

        // menu click on mobile
        hamburgerRef.current.addEventListener('click', () => {
            if (!mobileMenuRaf.current.classList.contains('menu-open')) {
                mobileMenuRaf.current.classList.add('menu-open');
                hamburgerRef.current.classList.add('menu-open');
                document.body.classList.add('stop-scroll')
                setTimeout(() => {
                    menuRef.current.style.cssText = `opacity:1;display:block`;
                }, 100)
                document.querySelector('.menu-bar').classList.add('menu-open')

                // disableBodyScroll(targetElement);
            } else {
                document.body.classList.remove('stop-scroll')
                menuRef.current.style.cssText = `opacity:0`;
                hamburgerRef.current.classList.remove('menu-open');
                setTimeout(() => {
                    mobileMenuRaf.current.classList.remove('menu-open')
                }, 1000)
                document.querySelector('.menu-bar').classList.remove('menu-open')

                // enableBodyScroll(targetElement);

            }
        })

        let getLinkTag = document.querySelectorAll('.mobile-menu__items__ul li a');

        for (let i of getLinkTag) {
            i.addEventListener('click', () => {
                menuRef.current.style.cssText = `opacity:0`;
                hamburgerRef.current.classList.remove('menu-open');
                setTimeout(() => {
                    mobileMenuRaf.current.classList.remove('menu-open')
                }, 1000)
                document.body.classList.remove('stop-scroll')

            })
        }

        // sub menu

        if (window.screen.width < 769) {
            let menuSub = document.querySelectorAll('.has-sub');
            let menuOpen = document.querySelector('.menu-down');
            let menuOpenInner = document.querySelector('.menu-down ul');

            for (let i of menuSub) {

                i.addEventListener('click', () => {

                    if (!i.classList.contains('menu-down')) {
                        let getLiLength = i.querySelectorAll('ul li').length * i.querySelector('ul li').offsetHeight - 20;
                        let ulSelect = i.querySelector('ul');
                        // console.log('getLiLength', getLiLength)
                        tl.to(ulSelect, {
                            duration: 0,
                            visibility: 'visible'
                        });

                        tl.to(ulSelect, {
                            duration: .4,
                            opacity: '1',
                            height: getLiLength,
                            marginTop: '30px'
                        });
                        i.classList.add('menu-down');
                    } else {
                        let hasMenuDown = i.querySelector('ul');
                        tl.to(hasMenuDown, {
                            duration: .4,
                            height: 0,
                            opacity: 0,
                            marginTop: '0px',
                            visibility: 'hidden'
                        });

                        setTimeout(() => {
                            i.classList.remove('menu-down')
                        }, 500)
                    }

                })

            }
        }


    }, [mobileMenuRaf]);





    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);

    const handleScroll = () => {
        const currentScrollPos = window.pageYOffset;
        // const isScrollingUp = currentScrollPos < prevScrollPos;
        const isScrollingDown = currentScrollPos > prevScrollPos;


        // setVisible(isScrollingUp);
        setVisible(currentScrollPos < 100 || !isScrollingDown);
        setPrevScrollPos(currentScrollPos);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [prevScrollPos]);

    useEffect(() => {
        gsap.timeline().to('.main-menu', {
            opacity: 0,
            duration: 0,
        }).to('.main-menu', {
            opacity: 1,
            delay: 1.5,
            duration: 1
        })
    }, [location.pathname])

    return (
        <StyledMenu className={`menu-bar main-menu ${visible ? 'visible' : 'hidden'} ${getMenuClass(location.pathname)}`}>
            <Container>
                <Row className={`desktop-menu `}>
                    <Col sm={3} className='align-items-center d-flex'>
                        <Link to={'/'}><img height={60} src={'/images/static/mitali-logo.svg'} alt="mainLogo"/></Link>
                    </Col>

                    <Col sm={9}>
                        <ul className=''>
                            <li className={pathname === '/' ? 'active' : ''} ><Link to={'/'}>Home</Link></li>
                            <li className='has-sub'>About
                                <span><img src={'/images/static/caret-down.svg'} alt={'caret'}/></span>
                                <ul>
                                    <li className={pathname === '/about' ? 'active' : ''} ><Link
                                        to={'/about'}>About Us</Link>
                                        {/*<svg xmlns="http://www.w3.org/2000/svg" width="8.121" height="14.121" viewBox="0 0 8.121 14.121">*/}
                                        {/*    <g id="Group_23869" data-name="Group 23869" transform="translate(787.061 442.061)">*/}
                                        {/*        <line id="Line_352" data-name="Line 352" x2="6" y2="6" transform="translate(-786 -429) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*        <line id="Line_353" data-name="Line 353" x1="6" y2="6" transform="translate(-786 -435) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*    </g>*/}
                                        {/*</svg>*/}
                                    </li>
                                    <li className={pathname === '/what-we-do' ? 'active' : ''} ><Link to={'/what-we-do'}>What We Do</Link>
                                        {/*<svg xmlns="http://www.w3.org/2000/svg" width="8.121" height="14.121" viewBox="0 0 8.121 14.121">*/}
                                        {/*    <g id="Group_23869" data-name="Group 23869" transform="translate(787.061 442.061)">*/}
                                        {/*        <line id="Line_352" data-name="Line 352" x2="6" y2="6" transform="translate(-786 -429) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*        <line id="Line_353" data-name="Line 353" x1="6" y2="6" transform="translate(-786 -435) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*    </g>*/}
                                        {/*</svg>*/}
                                    </li>
                                </ul>
                            </li>
                            <li className={pathname === '/business-units' ? 'active' : ''} ><Link
                                to={'/business-units'}>Business Units</Link></li>
                            <li className={pathname === '/product' ? 'active' : ''} ><Link to={'/product'}>Products</Link></li>
                            <li className={pathname === '/sustainability' ? 'active' : ''} ><Link to={'/sustainability'}>Sustainability</Link></li>
                            <li className={pathname === '/media-center' ? 'active' : ''} ><Link to={'/media-center'}>Media</Link></li>
                            <li className='has-sub'>Contact
                                <span><img src={'/images/static/caret-down.svg'} alt={'caret'}/></span>
                                <ul>
                                    <li className={pathname === '/career' ? 'active' : ''}><Link
                                        to={'/career'}>Career</Link>
                                        {/*<svg xmlns="http://www.w3.org/2000/svg" width="8.121" height="14.121" viewBox="0 0 8.121 14.121">*/}
                                        {/*    <g id="Group_23869" data-name="Group 23869" transform="translate(787.061 442.061)">*/}
                                        {/*        <line id="Line_352" data-name="Line 352" x2="6" y2="6" transform="translate(-786 -429) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*        <line id="Line_353" data-name="Line 353" x1="6" y2="6" transform="translate(-786 -435) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*    </g>*/}
                                        {/*</svg>*/}
                                    </li>
                                    <li className={pathname === '/contact' ? 'active' : ''}><Link
                                        to={'/contact'}>Contact Us</Link>
                                        {/*<svg xmlns="http://www.w3.org/2000/svg" width="8.121" height="14.121" viewBox="0 0 8.121 14.121">*/}
                                        {/*    <g id="Group_23869" data-name="Group 23869" transform="translate(787.061 442.061)">*/}
                                        {/*        <line id="Line_352" data-name="Line 352" x2="6" y2="6" transform="translate(-786 -429) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*        <line id="Line_353" data-name="Line 353" x1="6" y2="6" transform="translate(-786 -435) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-width="1.5"/>*/}
                                        {/*    </g>*/}
                                        {/*</svg>*/}
                                    </li>

                                </ul>
                            </li>
                        </ul>
                    </Col>

                </Row>


                <Row className="mobile-menu" id="mobile-menu" ref={mobileMenuRaf}>
                    <Col className='logo'>
                        <Link to={'/'}><img src={'/images/static/mitali-logo.svg'} alt="mainLogo"/></Link>
                    </Col>

                    <Col className='hamburger' ref={hamburgerRef}>
                        <img src={'/images/static/hamb.svg'} alt=""/>
                        <img src={'/images/static/hamburger-close.svg'} alt=""/>
                    </Col>

                    <div className="mobile-menu__items" ref={menuRef}>
                        <ul className='mobile-menu__items__ul'>
                            <li><Link to={'/'}>Home</Link></li>

                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>About<img src={'/images/static/cicle-caret.svg'} alt={'caret'}/></Accordion.Header>
                                    <Accordion.Body>

                                        <ul>
                                            <li><Link to={'/about'}>About</Link>

                                            </li>
                                            <li><Link to={'/what-we-do'}>What We Do</Link>

                                            </li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <li><Link to={'/business-units'}>Business Unit </Link></li>
                                <li><Link to={'/product'}>Products</Link></li>
                                <li><Link to={'/sustainability'}>Sustainability</Link></li>
                                <li><Link to={'/media-center'}>Media</Link></li>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Contact <img src={'/images/static/cicle-caret.svg'} alt={'caret'}/></Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li><Link to={'/career'}>Career</Link></li>
                                            <li><Link to={'/contact'}>Contact</Link></li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>


                            </Accordion>

                        </ul>
                    </div>

                </Row>

            </Container>
        </StyledMenu>
    )
};

const StyledMenu = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  z-index: 1000;
  background-color: rgba(42, 38, 39, 0.1);
  display: flex;
  align-items: center;
  transition: all 0.5s ease 0s;
  //backdrop-filter: blur(2px);
  &.hidden {
    transform: translateY(-100%);
  }

  &.visible {
    transform: translateY(0);
  }
    &.menu-fixed{
        background: rgba(0,0,0,0.5);
    }
    &.fade{
        opacity:0;
    }
    &.unfade{
        opacity: 1;
    }

  img {
    //height: 70px;
  }

  .desktop-menu {
    ul {
      display: flex;
      justify-content: flex-end;

      li {
        display: flex;
        height: 85px;
        align-items: center;
        color: #ffffff;
        font-size: 15px;
        margin-right: 35px;
        cursor: pointer;
          
        a {
          display: flex;
          height: 80px;
          align-items: center;
          color: #ffffff;
          font-size: 15px;
          line-height: 22px;
          font-weight: 400;
            
        }
          &:hover {
              color: #FFFFFF !important;
              a{
                  color: #ffffff !important;
              }
          }
        &:nth-last-child(1) {
          margin-right: 0;
        }
          
          &.active{
              a{
                  font-weight: 600;
              }
          }

        &.has-sub {
          position: relative;

          &:hover{
            span{
              img{
                transform: rotate(180deg);
              }
            }
          }
          span {
            margin-left: 10px;
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #FFF;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            &:after {
              content: '';
              height: 0;
              width: 0;
              background-color: #8A1313;
              position: absolute;
              border-radius: 50%;
              transition: all .1s ease;
            }

            img {
              height: 4px;
              z-index: 3;
              transform: rotate(0deg);
              transition: transform 0.3s ease;

            }
          }

          ul {
            opacity: 0;
            position: absolute;
            visibility: hidden;
            top: 100px;
            left: -60px;
            //transform: translateY(50px);
            overflow: hidden;
            min-width: 200px;
            background-color: #2A2627;
            //padding: 30px;
            justify-content: start;
            transition: all 0.3s ease;
            display: flex;
            flex-wrap: wrap;
            //box-shadow: 0px 6px 13px rgba(255, 255, 255, 0.05);
            box-shadow: 0 6px 30px rgb(0 0 0 / 24%);
            margin-top: -15px;
            z-index: -5;
            //
            // &:after {
            //   content: '';
            //   width: 0;
            //   height: 0;
            //   border-left: 0px solid transparent;
            //   border-right: 18px solid transparent;
              //   border-bottom: 16px solid ${hover};
            //   top: -16px;
            //   position: absolute;
            // }

            li {
              height: auto;
              margin: 0;
              width: 100%;
              padding-left: 30px;
              padding-right: 30px;
              //display: flex;
              //justify-content: flex-start;
              transition: 0.3s ease-in-out;
              position: relative;
              a{
                transition: 0.3s ease-in-out;
                color: #FFFFFF;
                font-size: 15px;
                line-height: 22px;
                font-weight: 400;
                border-bottom: 1px solid rgba(112, 112, 112, 0.5);
                width: 100%;
              }
              svg{
                width: 10px;
                height: 10px;
                opacity: 0;
                transition: all 0.3s ease;
                position: absolute;
                right: 100px;
              }
              
              &:hover {
                a {
                    letter-spacing: 1px;
                    color: white !important;
                }
                svg{
                  opacity: 1;
                  right: 30px;
                  left: unset;
                }
                
              }

              a {
                height: auto;
                font-size: 16px;
                line-height: 24px;
                padding: 10px 0 10px 0;
                white-space: nowrap;
                  
              }
              &:nth-last-child(1) a {
                margin-bottom: 0;
                border-bottom: none;
              }
            }
          }
        }
        
        &:hover {
          span {
            border-color: #8A1313;

            &:after {
              height: 100%;
              width: 100%;
            }
          }

          ul {
            opacity: 1;
            visibility: visible;
            transform: translateY(0px);
            z-index: 555;
              li{
                  a{
                      color: white !important;
                  }
              }

          }
        }

        &:nth-last-child(1) {
          ul {
            left: -109px;

            &:after {
              right: 50px;
            }
          }
        }
      }

    }
  }

  .mobile-menu {
    display: none;

    .logo img {
      height: 40px;
    }

    .hamburger {
      position: relative;
      display: flex;
      align-items: center;

      img {
        position: absolute;
        right: 15px;
        height: 25px;

        &:nth-of-type(1) {

        }

        &:nth-of-type(2) {
          display: none;
        }
      }

      &.menu-open img {
        &:nth-of-type(1) {
          display: none;
        }

        &:nth-of-type(2) {
          display: block;
          right: 20px;
        }
      }
    }

    &__items {
      display: none;
      position: absolute;
      opacity: 0;
      background-color: #3C4348;
      height: 100vh;
      top: 70px;
      left: 0;
      width: 100%;
      z-index: 99;
      padding: 60px 15px 60px 15px;
      overflow: auto;
      transition: opacity .5s ease;

      ul {
          
          &.mobile-menu__items__ul{
              overflow-y: scroll;
              height: 100vh;
          }
        li {
          padding-bottom: 16px;
          border-bottom: 1px solid #FFF;
          margin-bottom: 30px;
          font-size: 15px;
          text-transform: capitalize;

          a {
            color: #ffffff;
          }
        }
      }
    }

    &.menu-open {

      .mobile-menu__items {
        display: block;
          
      }

    }

    //accordion
    .accordion-header {
      .accordion-button {
        background-color: transparent;
        font-size: 15px;
        line-height: 20px;
        color: #ffffff;
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: space-between;
        padding: 0;
        box-shadow: none;
        border: none;
        margin-bottom: 32px;
        padding-bottom: 16px;
        border-bottom: 1px solid #CFCDCC;
        font-family: ${titletwo};
        img {
          height: 20px;
        }

        &.collapsed {
          border-bottom: 1px solid #FFF;
        }
      }


    }

    .accordion-body {
      margin-bottom: 50px;

      ul {
        li {
          border: none;
          margin-bottom: 22px;
          padding-bottom: 0;

          &:after {
            display: none;
          }
        }
      }
    }


  }
  

  &.menu-fixed{
    //background-color: rgba(60, 67, 72, 0.35);
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.24);
  } 
  &.menu-open {
    background-color: #3C4348;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.24);
    
  }

  .active a {
    //color: #FFFFFF !important;
  }


  @media (max-width: 769px) {
    background-color: rgba(60, 67, 72, 0.35);
    //border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    height: 70px;
    overflow: visible;
    .desktop-menu {
      display: none;
    }

    .mobile-menu {
      display: flex;
    }

    &:after {
      content: '';
      position: absolute;
      right: 97px;
      height: calc(100%);
      width: 1px;
      //background-color: rgba(255, 255, 255, 0.77);
      top: 0px;
    }

  }

  @media (max-width: 767px) {
    background-color: rgb(60, 67, 72);
    &.menu-fixed{
      //background-color: rgb(60, 67, 72);
    }
    &:after {
      right: 65px;
    }
  }
.menu-bar{
  @media (max-width: 767px){
    background-color: red;
  }
}

`;



export default Menu;
